import { ProgressBar, ProgressBarProps } from '@ui/components/ProgressBar'

import { Box } from '@shared/components/Box'

interface Props extends Omit<ProgressBarProps, 'percent'> {
  sections: { id?: string; percentage: number; delay?: number; onClick?: () => void }[]
}

export const ProgressBarGroup = (props: Props) => {
  const { sections, ...progressBarProps } = props

  return (
    <Box flex align='center' fullWidth gap='x16' justify='center'>
      {sections.map((section, index) => (
        <Box
          key={section.id ?? `progress-bar-group-section-${index}`}
          fullWidth
          onClick={section.onClick}
        >
          <ProgressBar {...progressBarProps} percent={section.percentage} delay={section.delay} />
        </Box>
      ))}
    </Box>
  )
}
